import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=ee26ac82&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports